"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_button_1 = __importDefault(require("@doordash/component-button"));
var component_logo_1 = __importDefault(require("@doordash/component-logo"));
var design_language_1 = require("@doordash/design-language");
var lodash_1 = require("lodash");
var React = __importStar(require("react"));
var InternalAppStyles_1 = require("./InternalAppStyles");
var NavBarItem = function (link, key) {
    return (React.createElement(InternalAppStyles_1.DropdownContent, { key: key },
        React.createElement(InternalAppStyles_1.Link, { href: link.to, key: lodash_1.camelCase(link.name) },
            React.createElement(design_language_1.Text, { color: design_language_1.Colors.BrandOceanDark }, link.name),
            link.pages && (React.createElement(design_language_1.Icon, { color: design_language_1.Icon.Colors.BrandOceanDark, size: design_language_1.Icon.Sizes.Small, type: design_language_1.Icon.Types.ArrowRight }))),
        link.pages && (React.createElement(InternalAppStyles_1.Dropdown, null, link.pages.map(function (page, index) { return NavBarItem(page, index); })))));
};
var NavBar = function (_a) {
    var _b = _a.links, links = _b === void 0 ? [] : _b, title = _a.title, _c = _a.userName, userName = _c === void 0 ? 'Admin' : _c, _d = _a.to, to = _d === void 0 ? '/' : _d, _e = _a.logoutUrl, logoutUrl = _e === void 0 ? '/' : _e;
    return (React.createElement(InternalAppStyles_1.NavBarContainer, null,
        React.createElement(InternalAppStyles_1.NavLinksContainer, null,
            React.createElement(InternalAppStyles_1.Link, { href: to },
                React.createElement(component_logo_1["default"], { showLogoText: false, text: title, textColor: design_language_1.Colors.BrandOceanDark })),
            React.createElement(InternalAppStyles_1.Dropdown, null, links.map(function (link, index) { return NavBarItem(link, index); }))),
        React.createElement(design_language_1.InlineChildren, { alignItems: design_language_1.InlineChildren.Alignment.Center },
            !!userName && React.createElement(design_language_1.Text, { color: design_language_1.Text.Colors.Black }, userName),
            React.createElement(InternalAppStyles_1.Link, { href: logoutUrl },
                React.createElement(component_button_1["default"], { isInline: true, type: component_button_1["default"].Types.Secondary }, "Logout")))));
};
exports["default"] = NavBar;
